import {appInstance} from '@/utils/app-accessor'
import {authStore} from '@/composables/store-accessor'
import {PersonRole} from '~/utils/types/types'

export default defineNuxtRouteMiddleware(() => {
    const personRole = authStore.personRole
    const companyType = authStore.companyType

    // Allow access for Director role or TO1 role users
    if (
        personRole !== PersonRole.Director &&
        personRole !== PersonRole.Supervisor &&
        personRole !== PersonRole.Support &&
        companyType !== 'TOUR_OPERATOR_1LEVEL'
    ) {
        throw createError({statusCode: 403, message: appInstance.$i18n.t('error_message.forbidden')})
    }
})
